import { findKeyInObj } from '../../utils/objects';
import { mix } from '../../utils/color';
import { noticeError } from 'app/api/analytics/reporting';

/**
 * Convert color names like "common.IconButton" to
 * {
 *    "common.IconButton": "#00ff00"
 * }
 * Includes color mixing
 * Mostly used for complex color applications
 */
export function getColors(theme, ...colors) {
  const result = {};
  colors.forEach(c => {
    const val = findKeyInObj(theme, c);
    if (val) {
      const [name, alphaStr] = val.split('@');
      const hex = findKeyInObj(theme.colors, name);
      if (hex) {
        const alpha = parseFloat(alphaStr) || 1;
        let toMix = '#FFFFFF';
        if (alpha < 0) {
          toMix = '#000000';
        }
        result[c] = mix(hex, toMix, Math.abs(alpha) * 100);
      } else {
        noticeError(`Could not find color: ${name}`);
      }
    } else {
      noticeError(`Could not find color: ${c}`);
    }
    if (!result[c]) {
      result[c] = '#000000';
    }
  });
  return result;
}

export function getColor(theme, color) {
  return getColors(theme, color)[color];
}
